<app-notifications></app-notifications>

<app-error-overlay></app-error-overlay>

<div
  class="app-container"
  [ngClass]="[(currentTheme$ | async) || '']"
  [class.picture-background]="isPictureBackground$ | async"
>
  <app-confetti-overlay></app-confetti-overlay>
  <router-outlet></router-outlet>
</div>
